import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface AccountState {
  organization: string;
  setOrganization: (value: string) => void;

  organizationImage: any;
  setOrganizationImage: (value: string) => void;

  organisationImageSize: number;
  setOrganisationImageSize: (value: any) => void;

  organizationLogo: any;
  setOrganizationLogo: (value: any) => void;
  organisationLogoSize: number;
  setOrganisationLogoSize: (value: number) => void;
}

export const useAccountStore = create<AccountState, [['zustand/devtools', AccountState]]>(
  devtools((set) => ({
    organization: '',
    setOrganization: (organization) => set({ organization: organization }),
    organizationImage: '',
    setOrganizationImage: (organizationImage) => set({ organizationImage: organizationImage }),

    organisationImageSize: 0,
    setOrganisationImageSize: (organisationImageSize) => set({ organisationImageSize }),

    organizationLogo: null,
    setOrganizationLogo: (organizationLogo) => set({ organizationLogo: organizationLogo }),
    organisationLogoSize: 0,
    setOrganisationLogoSize: (organisationLogoSize) => set({ organisationLogoSize }),
  }))
);
